import { useState } from 'react'
import Slider from "react-slick";
import styles from './styles.module.css'


export default function AndamentoObras({ data }) {
  const [show, setShow] = useState(false)

  function NextArrow({ className, style, onClick }) {
    return (
      <div className={className} onClick={onClick} style={{ ...style, display: "block" }}>
        <img src='/icons/nextArrowRed.png' width={16} />
      </div>
    )
  }

  function PrevArrow({ className, style, onClick }) {
    return (
      <div className={className} onClick={onClick} style={{ ...style, display: "block" }}>
        <img src='/icons/prevArrowRed.png' width={16} />
      </div>
    )
  }



  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: 'obras',
    autoplay: true,
    autoplaySpeed: 1800,
    fade: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  const settings2 = {
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2400,
  };

  return (
    <section style={{ overflowX: 'hidden' }} className={styles.container}>
      <Slider {...settings2}>
        {
          data &&
          data?.modulos?.map(item => {
            return (
              <div key={item.id} className={styles.content}>
                <div>
                  <div className={styles.title}>
                    <div className={styles.parallelogramDetail} />
                    <h2>
                      <strong>Acompanhamento</strong><br/> <span style={{fontWeight: '300', lineHeight: '1.8'}}>das Obras</span>
                    </h2>
                  </div>
                  <div className={styles.description}>
                    <span><strong>Última atualização: </strong>{item.nome}</span>
                  </div>
                  <div
                    className={styles.etapas}
                    style={{ height: show ? 'auto' : '420px' }}
                  >
                    {
                      item.etapas.map(etapa => {
                        return (
                          <div key={etapa.id} className={styles.bar}>
                            <span>{etapa.nome}</span>
                            <div style={{ display: 'flex', flexDirection: 'row'}}>
                              <div className={styles.progress}>
                                <div style={{ width: `${etapa.porcentagem}%` }}></div>
                              </div>
                              <span style={{ position: 'relative', left: '12px' }}>{`${etapa.porcentagem}%`}</span>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                  {
                    item.etapas.length > 5 ?
                      <button className={styles.button} onClick={() => setShow(!show)}>
                        <img src="/icons/icone-botao.png" alt="Abrir todo o texto" width={12} height={24} />
                        <span>{show ? "Esconder status" : "Abrir todo o status"}</span>
                      </button> : <></>
                  }
                </div>
                <div className={styles.carousel_content}>
                  <div className={styles.carousel}>
                    <Slider {...settings}>
                      {
                        item.galeria.map(itemImg => {
                          return (
                            <div>
                              <img src={itemImg.img.url} />
                            </div>
                          )
                        })
                      }
                    </Slider>
                  </div>
                </div>
              </div>
            )
          })
        }
      </Slider>
    </section>
  )
}
